import AddIcon from "@mui/icons-material/Add";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ArrowDropUpOutlinedIcon from "@mui/icons-material/ArrowDropUpOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../services/authContext";
import { DropDown, SidebarDiv } from "./style";
import Vivo from "../../assets/img/vivo.png";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Sidebar = () => {
  const [dropdown, setDropdown] = useState(false);
  const [dropdownConfig, setDropdownConfig] = useState(false);
  const [dropdownModule, setDropdownModule] = useState(false);
  const { auth } = useContext(AuthContext);

  const showOldReport = process.env.REACT_APP_REPORT_OLD_SHOW === "true";

  console.log("AQUI", process.env.API_BASE_URL);
  
  return (
    <SidebarDiv>
      <div className="top">
        <div className="logo">
          <img src={Vivo} alt="Logo" />
        </div>
      </div>
      {/* <hr /> */}
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <li>
            <a href="/web/" className="page">
              <DashboardIcon className={"icon"} />
              <span>Home</span>
            </a>
          </li>

          <p className="title">REPORTS</p>

          {auth.access.modReports > 0 && (
            <li>
              <Link to="/newweb/reports" className="page">
                <ListAltIcon className={"icon"} />
                <span>Reports</span>
              </Link>
            </li>
          )}

          {(auth.access.modReports > 0 && showOldReport) && (
            <li>
              <Link to="/newweb/reports.old" className="page">
                <ListAltIcon className={"icon"} />
                <span>Reports Antigos</span>
              </Link>
            </li>
          )}

          {auth.access.modReports > 0 && (
            <li>
              <Link to="/newweb/downloads" className="page">
                <FileDownloadIcon className={"icon"} />
                <span>Downloads</span>
              </Link>
            </li>
          )}

          {/* {auth.access.modSystem > 0 && (
            <li>
              <Link to="/newweb/add" className="page">
                <AddIcon className={"icon"} />
                <span>Add Lead</span>
              </Link>
            </li>
          )} */}

          {(auth.access.modCampaigns === 1 ||
            auth.access.modEngines === 1 ||
            auth.access.modCalendars === 1 ||
            auth.access.modProducts === 1 ||
            auth.access.modGenerators === 1 ||
            auth.access.modConverters === 1) && (
              <li>
                <DropDown>
                  <div className="dp" onClick={() => setDropdown(!dropdown)}>
                    <div className="dp-page">
                      <CampaignOutlinedIcon className={"icon"} />
                      <span>Campaign</span>
                    </div>
                    {dropdown ? (
                      <ArrowDropUpOutlinedIcon className={"icon"} />
                    ) : (
                      <ArrowDropDownOutlinedIcon className={"icon"} />
                    )}
                  </div>
                  {dropdown && (
                    <ul className="dp-children">
                      {auth.access.modCampaigns > 0 && (
                        <li>
                          <Link to="/newweb/campaigns" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Campaigns</span>
                          </Link>
                        </li>
                      )}

                      {auth.access.modEngines > 0 && (
                        <li>
                          <Link to="/newweb/engines" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Engines</span>
                          </Link>
                        </li>
                      )}

                      {auth.access.modCalendars > 0 && (
                        <li>
                          <Link to="/newweb/calendars" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Calendars</span>
                          </Link>
                        </li>
                      )}

                      {auth.access.modProducts > 0 && (
                        <li>
                          <Link to="/newweb/products" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Products</span>
                          </Link>
                        </li>
                      )}

                      {auth.access.modGenerators > 0 && (
                        <li>
                          <Link to="/newweb/generators" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Generatos</span>
                          </Link>
                        </li>
                      )}

                      {auth.access.modConverters > 0 && (
                        <li>
                          <Link to="/newweb/transformers" className="page">
                            <ArrowDropDownOutlinedIcon className={"icon"} />
                            <span>Transformers</span>
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </DropDown>
              </li>
            )}
          <li>
            <DropDown>
              <div
                className="dp"
                onClick={() => setDropdownConfig(!dropdownConfig)}
              >
                <div className="dp-page">
                  <CampaignOutlinedIcon className={"icon"} />
                  <span>Configuration</span>
                </div>
                {dropdownConfig ? (
                  <ArrowDropUpOutlinedIcon className={"icon"} />
                ) : (
                  <ArrowDropDownOutlinedIcon className={"icon"} />
                )}
              </div>
              {dropdownConfig && (
                <ul className="dp-children">
                  {auth.access.modCampaigns > 0 && (
                    <li>
                      <Link to="/newweb/config" className="page">
                        <ArrowDropDownOutlinedIcon className={"icon"} />
                        <span>Schedule Time</span>
                      </Link>
                    </li>
                  )}

                  {auth.access.modEngines > 0 && (
                    <li>
                      <Link to="/newweb/api" className="page">
                        <ArrowDropDownOutlinedIcon className={"icon"} />
                        <span>API User</span>
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </DropDown>
          </li>
          <li>
            <DropDown>
              <div
                className="dp"
                onClick={() => setDropdownModule(!dropdownModule)}
              >
                <div className="dp-page">
                  <CampaignOutlinedIcon className={"icon"} />
                  <span>Modules</span>
                </div>
                {dropdownModule ? (
                  <ArrowDropUpOutlinedIcon className={"icon"} />
                ) : (
                  <ArrowDropDownOutlinedIcon className={"icon"} />
                )}
              </div>
              {dropdownModule && (
                <ul className="dp-children">
                  {auth.access.modCampaigns > 0 && (
                    <li>
                      <Link to="/newweb/dam" className="page">
                        <ArrowDropDownOutlinedIcon className={"icon"} />
                        <span>Dam</span>
                      </Link>
                    </li>
                  )}

                  {auth.access.modEngines > 0 && (
                    <li>
                      <Link to="/newweb/project" className="page">
                        <ArrowDropDownOutlinedIcon className={"icon"} />
                        <span>Project</span>
                      </Link>
                    </li>
                  )}
                </ul>
              )}
            </DropDown>
          </li>
          {auth.access.modSystem > 0 && (
            <li>
              <Link to="/newweb/mngr_users" className="page">
                <ArrowDropDownOutlinedIcon className={"icon"} />
                <span>Manager Users</span>
              </Link>
            </li>
          )}

          {auth.status === "OK" && (
            <li>
              <a href="/web/" className="page">
                <KeyboardReturnIcon className={"icon"} />
                <span>BACK TO OLD SYSTEM</span>
              </a>
            </li>
          )}
        </ul>
      </div>
      <div className="bottom"></div>
    </SidebarDiv>
  );
};

export default Sidebar;
